function initSlider() {
  const $slider = $('.js-slider');

  if (!$slider.length) return;

  // 一回destroyしてから再初期化
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

$slider.slick({
  arrows: false,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1200,
  infinite: true,

  fade: true,          // ←これ追加
  cssEase: 'ease-in-out',

  pauseOnHover: false,
  pauseOnFocus: false,
  pauseOnDotsHover: false
});
}

document.addEventListener('DOMContentLoaded', initSlider);
document.addEventListener('shopify:section:load', initSlider);